import { useUpdateShopMutation } from '../store/shops-api';
import { handleShopUpdateError } from '../utils/helpers/shops-errors';
import { useShowResponseStatus } from '@/shared';

import type { TShopUpdateParams } from '../store/types';

export const useUpdateShop = () => {
  const [updateShop, { isLoading, isSuccess, error }] = useUpdateShopMutation();
  const updateError = handleShopUpdateError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Данные магазина успешно обновлены',
    error: updateError,
  });

  const handleShopEdit = async (params: TShopUpdateParams) => {
    await updateShop(params);
  };

  return {
    handleShopEdit,
    updateShop,
    isLoading,
  };
};
